import { apiClient } from "shared/utils";
import { format } from "date-fns";
import { UpliftMetricsResponse } from "api/models";

export const getUpliftMetrics = async (shopId: number, startDate: Date, endDate: Date) => {
  const { data } = await apiClient.get<UpliftMetricsResponse>(
    `/${shopId}/dashboard/uplift-metrics`,
    {
      params: {
        startDate: format(startDate, "yyyy-MM-dd"),
        endDate: format(endDate, "yyyy-MM-dd")
      }
    }
  );

  return data;
};
